<template>
	<div class="main-sidebar" :class="{'sidebar-hide': !menuVisible, 'fixed-top': menuStickyStyles}" ref="menuSticky" :style="{'--percent': scrollPercenatge}">
		<LanguageSelector :languages="languageList" v-if="featureSet.mainMenu.hasLanguageBar"/>

		<a class="mygroups" v-if="$store.state.CID === 13" href="https://mygroups.ags-weiterbildung.de" target="_blank">MyGroups Login</a>
		<router-link to="/" class="sidebar-logo-link" v-if="featureSet.mainMenu.hasLogo">
			<div class="sidebar-logo-svg" :class="menuStickyStyles" @click="menuVisible = false" v-if="featureSet.mainMenu.svgLogo">
				<inline-svg
				v-for="(part, index) in featureSet.mainMenu.svgParts[$store.state.CID]"
				:key="index"
				:src="logoSrcSSvg(`logo${$store.state.CID}-${index}`)"
				:class="`logo-part-${index}`"
				></inline-svg>
			</div>
			<div class="sidebar-logo" :class="[logoStyling, menuStickyStyles]" @click="menuVisible = false" v-else>
				<img class="sidebar-logo-small" :src="logoSrcS(false)">
				<img class="sidebar-logo-large" :src="logoSrc">
			</div>
		</router-link>
		<div class="menu-text" :class="menuStickyStyles" v-if="featureSet.mainMenu.hasTextInMenu" ref="menuText">{{ $store.state.headerText }}</div>
		<div class="hamburger-menu" @click="toggleMenu()" >
			<fa-icon icon="times" v-if="menuVisible"/>
			<fa-icon icon="bars" v-else/>
		</div>
		<div class="header-page" v-if="featureSet.header.headerPage && generalSettings['header_page']">
			<PageView :id="generalSettings['header_page']" :no-title="true" :no-title-update="true" />
		</div>
		<nav v-if="dataAvailable" :class="[{'menu-hide': !menuVisible}, menuStickyStyles]">

			<!-- OLD MENUS -->
			<template v-if="!featureSet.mainMenu.isFlex">
				<template v-for="(node, index) in sidebarMenu">
					<ul class="helper-mobile-invisible" :key="index + 'helper-even'"
						v-if="featureSet.mainMenu.logoCentered && sidebarMenu.length % 2 === 0 && Math.floor(sidebarMenu.length / 2) === index">
						<li></li>
					</ul>
					<template v-if="featureSet.mainMenu.logoCentered && sidebarMenu.length % 2 === 1">
						<ul class="helper-mobile-invisible" :key="index + 'helper-odd1'"
							v-if="0 === index ">
							<li></li>
						</ul>
						<ul class="helper-mobile-invisible" :key="index + 'helper-odd2'"
							v-if="Math.floor(sidebarMenu.length / 2) === index">
							<li></li>
						</ul>
					</template>

					<MenuItem
						:node="node"
						:key="index"
						@item-clicked="toggleMenu()"/>
				</template>
			</template>

			<!-- NEW MENUS -->
			<div class="flex-menu" v-if="featureSet.mainMenu.isFlex">
				<div class="menu-half">
					<MenuItem
						v-for="(node, index) in splitMenuArrays.firstHalf"
						:node="node"
						:key="index"
						@item-clicked="toggleMenu()"/>
				</div>
				<div class="menu-centered-logo" v-if="featureSet.mainMenu.logoCenteredFlex">
					<router-link
					:to="'/'"
					tag="img"
					class="sidebar-logo-large"
					:src="logoSrc"></router-link>
				</div>
				<div class="menu-half">
					<MenuItem
						v-for="(node, index) in splitMenuArrays.secondHalf"
						:node="node"
						:key="index"
						@item-clicked="toggleMenu()"/>
				</div>
				<SocialIcons class="flex-menu-social-icons"/>
			</div>


			<LanguageSelector v-if="featureSet.footer.footerInSidebar && featureSet.footer.hasLanguageBarInMenuFooter" :languages="languageList"/>
			<div class="site-footer-page" v-if="featureSet.footer.hasPageInFooter">
				<!-- <div v-html="JSON.parse(getContentById('pages', 6).body)[language]"></div> -->
				<div class="footer-page" v-if="featureSet.footer.footerPage && generalSettings['footer_page']">
					<PageView :id="generalSettings['footer_page']" :no-title="true" :no-title-update="true" />
				</div>
				<GenericMenu :menuArray="footerMenu" v-if="featureSet.footer.hasMenuInMenu" @generic-menu-item-click="toggleMenu()"/>
				<div class="social-icons-menu" v-if="featureSet.socialIcons.inMenuFooter">
					<SocialIcons />
				</div>
			</div>
			<div class="social-icons-menu" v-if="featureSet.socialIcons.inMenu">
				<SocialIcons />
			</div>
		</nav>

		<div class="site-footer" v-if="featureSet.footer.footerInSidebar">
			<GenericMenu :menuArray="footerMenu" v-if="featureSet.footer.hasMenuInMenu"/>
			<SocialIcons v-if="featureSet.footer.hasSocialInFooterInMenu" />
			<span v-if="featureSet.footer.hasCopyright" class="site-footer-copyright">Copyright {{ (new Date()).getFullYear() }} <br> {{ this.$store.state.cName }}</span>
			<div class="site-footer-logos" v-if="featureSet.footer.seal.footerInSidebar">
				<div class="site-footer-seal">
					<StampItem :type="featureSet.footer.seal.white ? 'white': 'black'"></StampItem>
				</div>
			</div>
		</div>
		<div class="menu-decoration" v-if="featureSet.mainMenu.menuDecoration">
			<fa-icon class="menu-decoration-circle left" icon="circle"/>
			<div class="menu-decoration-divider"></div>
			<fa-icon class="menu-decoration-circle right" icon="circle"/>
		</div>
	</div>
</template>

<script>
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';
import MenuItem from '@/components/MenuItem.vue';
import GenericMenu from '@/components/GenericMenu.vue';
import LanguageSelector from '@/components/LanguageSelector.vue';
import SocialIcons from '@/components/SocialIcons.vue';
import PageView from '@/views/PageView.vue';
import InlineSvg from 'vue-inline-svg';
import StampItem from '../components/StampItem.vue';

export default {
	name: 'MenuSidebar',
	components: {
		MenuItem,
		LanguageSelector,
		GenericMenu,
		SocialIcons,
		PageView,
		InlineSvg,
		StampItem,
	},
	mixins: [staticDataLoaderMixin, contentDataLoaderMixin, featureSetLoaderMixin],
	data() {
		return {
			menuVisible: false,
			menuSticky: {
				height: 0,
				logoHeight: 0,
				windowScrollTop: 0,
				windowWidth: 0,
			},
			menuStickyStyles: false,
			scrollPercenatge: 1,
		};
	},
	created() {
		window.addEventListener('scroll', this.handleScroll);
		if (this.featureSet.mainMenu.closeOnGlobalClick) {
			document.addEventListener('click', (() => () => {
				this.$root.$emit('node-expanded', { id: -1 });
			})());
		}
	},
	methods: {
		toggleMenu() {
			this.menuVisible = !this.menuVisible;
		},
		handleScroll() {
			if (this.$refs.menuSticky && this.$refs.menuText) {
				const diff = this.$refs.menuSticky.clientHeight - this.$refs.menuText.clientHeight;
				const sctop = document.documentElement.scrollTop;
				this.scrollPercenatge = 1 - (((100 * sctop) / diff) / 100);
				if (document.documentElement.scrollTop > (this.$refs.menuSticky.clientHeight - this.$refs.menuText.clientHeight)) {
					this.menuStickyStyles = 'fixed-top';
					this.scrollPercenatge = 0;
				} else {
					this.menuStickyStyles = false;
				}
			}
		},
	},
	computed: {
		sidebarMenu() {
			const mainMenuArray = this.allMenus.find(e => e.id === this.mainMenu).childrenArray;
			// force the first one out of the array for debug purposes
			// mainMenuArray.shift();
			return mainMenuArray;
		},
		splitMenuArrays() {
			const halfIdx = Math.ceil(this.sidebarMenu.length / 2);
			const firstHalf = this.sidebarMenu.slice(0, halfIdx);
			const secondHalf = this.sidebarMenu.slice(halfIdx, this.sidebarMenu.length);
			return { firstHalf, secondHalf };
		},
		logoStyling() {
			return {
				'sidebar-logo-centered': this.featureSet.mainMenu.logoCentered,
			};
		},
	},
};
</script>

<style src="@/styles/views/MenuSidebar/MenuSidebar.less" lang="less" scoped></style>
